import { render, staticRenderFns } from "./FallbackTitles.vue?vue&type=template&id=5c1d9aef&scoped=true"
import script from "./FallbackTitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./FallbackTitles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FallbackTitles.vue?vue&type=style&index=0&id=5c1d9aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1d9aef",
  null
  
)

export default component.exports